import { Rule, RuleType } from '.';
import { DeviceClassification } from './DeviceType';

const defaults: { [ruleType in RuleType]: Rule } = {
  '.CartAbandonment': {
    type: '.CartAbandonment',
    unsubscribeDefined: false,
  },

  '.BrowseAbandonment': {
    type: '.BrowseAbandonment',
    minSessionTime: 0,
  },

  '.ActiveBasketContainsItemWithId': {
    type: '.ActiveBasketContainsItemWithId',
    productItemIds: [],
  },

  '.ActiveBasketContainsItemWithName': {
    type: '.ActiveBasketContainsItemWithName',
    productItemNames: [],
  },

  '.ActiveBasketValueIsAtLeast': {
    type: '.ActiveBasketValueIsAtLeast',
    currency: 'USD',
    minValue: undefined,
  },

  '.ActiveBasketValueIsLessThan': {
    type: '.ActiveBasketValueIsLessThan',
    currency: 'USD',
    maxValue: undefined,
  },

  '.DeviceType': {
    type: '.DeviceType',
    deviceType: DeviceClassification.Desktop,
  },

  '.ExcludeEmailSource': {
    type: '.ExcludeEmailSource',
    excludedSources: [],
  },

  '.IncludeEmailSource': {
    type: '.IncludeEmailSource',
    includedSources: [],
  },

  '.ImpressionPathWhitelist': {
    type: '.ImpressionPathWhitelist',
    whitelist: [],
  },

  '.NoActiveMarketingPermission': {
    type: '.NoActiveMarketingPermission',
  },

  '.NoActiveSMSMarketingPermission': {
    type: '.NoActiveSMSMarketingPermission',
  },

  '.Geolocation': {
    type: '.Geolocation',
  },

  '.UserLoggedIn': {
    type: '.UserLoggedIn',
  },
};

export const getRuleDefault = (type: RuleType): Rule => ({
  ...defaults[type],
});
